/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { overviewQueryInputDataDirectionSchema } from './OverviewQueryInputDataDirectionSchema'
import { overviewQueryInputDataSortSchema } from './OverviewQueryInputDataSortSchema'

export const overviewQueryInputDataSchema = z.object({
	sort: overviewQueryInputDataSortSchema.optional().default('created_at'),
	direction: overviewQueryInputDataDirectionSchema.optional().default('desc'),
	status: z.array(
		z.union([
			z.literal('draft'),
			z.literal('review'),
			z.literal('publishing'),
			z.literal('active'),
			z.literal('completed'),
		]),
	).optional().default([]),
	from: z.iso.datetime().nullable().optional(),
	to: z.iso.datetime().nullable().optional(),
	campaignIds: z.array(z.string()).optional().default([]),
})

export type OverviewQueryInputDataSchema = z.infer<typeof overviewQueryInputDataSchema>
